import { z } from 'zod';
/**
 * 權限值類型
 * 支援字串、數字、布林值、null、陣列和物件
 */
const PermissionValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    z.array(z.any()),
    z.record(z.string(), z.any()),
]);
/**
 * 權限設定 Schema
 * 使用 record 結構，key 為權限名稱，value 為權限值
 * 例如：{ "products.create": true, "orders.view": true, "custom.max_items": 100 }
 */
export const PermissionsSchema = z
    .record(z.string(), PermissionValueSchema)
    .default({})
    .describe('權限設定（JSONB 格式）');
